import { Box, Menu, Pagination as Pagin } from 'grommet'
import { useSearchParams } from 'react-router-dom'

type Props = {
  count: number
  page: number
  setPage?: (page: number) => void
  limit?: number
  setLimit?: (limit: number) => void
  options: number[]
}

export const Pagination = ({ count, limit, options, page, setLimit, setPage }: Props) => {
  const [, setSearchParams] = useSearchParams()
  const handleParamChange = (key: 'limit' | 'page', value: string) => {
    setSearchParams(prev => {
      prev.set(key, value)
      return prev
    })
  }
  return (
    <Box direction="row" justify="between">
      <Pagin
        alignSelf="start"
        numberEdgePages={1}
        numberItems={count}
        numberMiddlePages={2}
        onChange={({ page }) => {
          setPage && setPage(page)
          handleParamChange('page', String(page))
        }}
        page={page}
        size="small"
        step={limit ? limit : 20}
      />
      <Menu
        dropProps={{ align: { bottom: 'bottom', left: 'left' } }}
        items={[
          ...options?.map(option => ({
            label: option,
            onClick: () => {
              setLimit && setLimit(option)
              setPage && setPage(1)
              handleParamChange('limit', String(option))
              handleParamChange('page', String(1))
            }
          }))
        ]}
        label={`${limit ? limit : 20} / page`}
        size="small"
        style={{
          border: '1px solid #A79A46',
          borderRadius: '100px',
          fontWeight: 400,
          height: '40px'
        }}
      />
    </Box>
  )
}

export * from './PatientPagination'
